import React from "react";
import { Code } from "./setup.style";
import useClipboard from "react-use-clipboard";

const CodeToCopy = ({ fxl_code }) => {
  const text = `{% if first_time_accessed %}
<script id="fxl_conversions" fxl_code="${fxl_code}" 
src="https://script.fixel.ai/script/conversions/fxl_conversions_v4.js">
</script>
<script>
  window.fxl && fxl('Purchase', {{ subtotal_price | money_without_currency }})
</script>
{% endif %}`;

  const [isCopied, setCopied] = useClipboard(text);

  return (
    <Code onClick={setCopied}>
      {text}
      <p>{isCopied ? "Copied to clipboard!" : "Click to copy"}</p>
    </Code>
  );
};
export default CodeToCopy;
